import script from "./WSNotify.vue?vue&type=script&setup=true&lang=ts"
export * from "./WSNotify.vue?vue&type=script&setup=true&lang=ts"

import "./WSNotify.vue?vue&type=style&index=0&id=3bf26b9c&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bf26b9c"]])

export default __exports__